import { Card, CardContent, Typography } from "@mui/material";

const formatCurrency = (value, currency) =>
  `${currency}${Number((value / 100) || 0).toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;

const formatNumber = (value) => Number(value || 0).toLocaleString();

export default function KPI({ title, value, currency }) {
  const display = currency != null ? formatCurrency(value, currency) : formatNumber(value);

  return (
    <Card sx={{ borderRadius: 3, height: "100%" }}>
      <CardContent>
        <Typography variant="body2" color="text.secondary">
          {title}
        </Typography>

        <Typography variant="h4" sx={{ mt: 1, fontWeight: 700 }}>
          {display}
        </Typography>
      </CardContent>
    </Card>
  );
}
